import React from "react";

import Button from "../../Components/Button";
import Modal from "../../Components/Modal";
import type { FormalRunningAccount } from "../../Store/Reducers/AssessmentSlice";

interface Props {
  accounts: FormalRunningAccount[] | null;
  accountNamesById?: Record<string, string>;
  onClose: () => void;
}

const FormalRunningConflictModal: React.FC<Props> = ({
  accounts,
  accountNamesById = {},
  onClose,
}) => {
  const list = accounts ?? [];
  return (
    <Modal
      isOpen={list.length > 0}
      toggle={onClose}
      title="Formal assessment already running"
      size="md"
    >
      <p className="mb-4 text-gray-700">
        {list.length === 1
          ? "A formal assessment is already in progress on this account."
          : `A formal assessment is already in progress on ${list.length} of the accounts you selected.`}{" "}
        Remove the account, or wait until that assessment is published.
      </p>
      <ul className="mb-4 max-h-40 overflow-y-auto text-sm text-gray-600">
        {list.map(a => (
          <li key={a.account_id} className="py-1">
            <span className="font-medium text-gray-800">
              {accountNamesById[a.account_id] || "Unknown account"}
            </span>
          </li>
        ))}
      </ul>
      <div className="flex justify-end">
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default FormalRunningConflictModal;
